import BackendDiagnosticsPage from "./BackendDiagnosticsPage";

export default BackendDiagnosticsPage;
